import React from "react";
import { convertToRGBAString } from "utils/helperFunctions";
import qmeter_logo from "../../assets/images/qmeter_logo.svg";
import { useSelector } from "react-redux";

function QmeterSection({ height, properties }) {
  const { isRTL } = useSelector((state) => state);
  const handleClick = () => {
    document.location.reload();
  };
  return (
    <div
      // xs={24}
      className="left-to-right-holder"
      style={{
        backgroundColor: convertToRGBAString(properties.page_header),
        position: "sticky",
        top: 0,
        zIndex: 100,
        height: height,
      }}
    >
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          height: "100%",
          //   width: "66%",
          display: "flex",
          alignItems: "center",
          justifyContent: isRTL ? "flex-end" : "flex-start",
        }}
        className="logo_wrapper"
      >
        <img
          onClick={handleClick}
          src={qmeter_logo}
          className="img-fluid logo"
          alt="Qmeter_logo"
        />
      </div>
    </div>
  );
}

export default QmeterSection;
